import { ColorEnum } from '@/constants/color'
import { isAndroid, isWeb } from '@/constants/environment'
import {
    MaterialTopTabNavigationEventMap,
    MaterialTopTabNavigationOptions,
    createMaterialTopTabNavigator,
} from '@react-navigation/material-top-tabs'
import { ParamListBase, TabNavigationState } from '@react-navigation/native'
import { withLayoutContext } from 'expo-router'
import { ComponentProps, FC } from 'react'

export const defaultScreenOptions: MaterialTopTabNavigationOptions = {
    tabBarIndicator: () => null,
    tabBarActiveTintColor: ColorEnum.BRICK_600,
    tabBarInactiveTintColor: ColorEnum.WHITE,
    tabBarItemStyle: { width: 'auto' },
    tabBarContentContainerStyle: {
        justifyContent: 'center',
        gap: 4,
        height: 60,
    },
    tabBarStyle: {
        elevation: 0,
        shadowOpacity: 0,
        ...(isWeb && { boxShadow: 'none' }),
    },
    sceneStyle: {
        backgroundColor: ColorEnum.WHITE,
    },
    animationEnabled: !isAndroid, // disable due to visual glitches during transition
}

const { Navigator: RawNavigator } = createMaterialTopTabNavigator()

type NavigatorProps = ComponentProps<typeof RawNavigator> & {
    screenOptions?: MaterialTopTabNavigationOptions
}

const Navigator: FC<NavigatorProps> = ({ screenOptions, ...rest }) => {
    const mergedScreenOptions = { ...defaultScreenOptions, ...screenOptions }

    return <RawNavigator screenOptions={mergedScreenOptions} {...rest} />
}

const TopTabs = withLayoutContext<
    MaterialTopTabNavigationOptions,
    typeof Navigator,
    TabNavigationState<ParamListBase>,
    MaterialTopTabNavigationEventMap
>(Navigator)

export default TopTabs
